import { CompanySupposedBeneficiary, UserProfile } from '__generated__/GQL';

import { CompanySupposedDirector } from '../types';

/**
 * Return true if the user already filled their profile
 */
export const getHasAlreadyFilledProfile = (
  profile: Pick<UserProfile, 'firstName' | 'lastName' | 'gender'>,
) => Boolean(profile.firstName && profile.lastName && profile.gender);

/**
 * Type guard to ensure a supposed beneficiary is a director.
 */
export const isSupposedDirector = (
  supposedBeneficiary: CompanySupposedBeneficiary,
): supposedBeneficiary is CompanySupposedDirector => {
  return Boolean(supposedBeneficiary.isDirector);
};
